import type { Account } from '@shared/products-types';
import { isPluginActive, isPluginSliceAvailable } from '@retail/plugins';
import { logger } from '@luna/logger';

import { gAPIAccountEntitySlice } from './gAPIAccountEntitySlice';
import { isExtBankCurrentAccount } from './services/typeService';
import { loadAccountImage } from './services/imageLoadingService';

function isAccountDeprecated(account: Account): boolean {
    if (!isPluginSliceAvailable()) {
        logger.error('plugins slice not available when expected');

        return false;
    }

    if (isExtBankCurrentAccount(account)) {
        return !isPluginActive('PI-BANKCONN');
    }

    return false;
}

function accountsFilter(accounts: Account[]): Account[] {
    return accounts.filter((account) => !isAccountDeprecated(account));
}

export const fetchGAPIAccounts = async (): Promise<Account[]> => {
    const accounts = await gAPIAccountEntitySlice.queryAll({
        accountsFilter,
    });

    accounts.forEach(({ hasImage, id }) => hasImage && loadAccountImage(id));

    return accounts;
};
